<dashboard-customer-kpi-display [metrics]="metrics"></dashboard-customer-kpi-display>
